module.exports = __webpack_public_path__ + "static/media/BackIcon.0042fe08.svg";